import SpriteSymbol from "../../../node_modules/svg-baker-runtime/browser-symbol.js";
import sprite from "../../../node_modules/svg-sprite-loader/runtime/browser-sprite.build.js";
var symbol = new SpriteSymbol({
  "id": "icon-工商银行",
  "use": "icon-工商银行-usage",
  "viewBox": "0 0 1024 1024",
  "content": "<symbol class=\"icon\" viewBox=\"0 0 1024 1024\" xmlns=\"http://www.w3.org/2000/svg\" xmlns:xlink=\"http://www.w3.org/1999/xlink\" id=\"icon-工商银行\"><defs><style type=\"text/css\"></style></defs><path d=\"M181.333333 514.090667C181.333333 336.170667 325.546667 192 503.466667 192a322.048 322.048 0 1 1 0 644.096A322.090667 322.090667 0 0 1 181.333333 514.133333z m322.090667 280.576a280.618667 280.618667 0 1 0 0-561.194667 280.618667 280.618667 0 0 0 0 561.194667zM317.44 351.189333h175.189333v51.328H368.256v48.469334h124.373333v140.032H368.256v59.306666h124.373333v45.738667H317.44v-156.842667h126.848v-42.496H317.44v-145.493333z m371.925333 0v145.493334h-126.848v42.538666h126.848v156.842667h-175.146666v-45.738667h124.288v-59.306666h-124.288V450.986667h124.288V402.517333h-124.288V351.146667h175.146666z\" fill=\"#B91D22\" p-id=\"2441\" /></symbol>"
});
var result = sprite.add(symbol);
export default symbol


//////////////////
// WEBPACK FOOTER
// ./src/icons/svg/工商银行.svg
// module id = iwl3
// module chunks = 107